export default __webpack_public_path__ + "static/media/not_found_md.1853ca3f.jpg";